import * as React from 'react';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import ArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import { useNavigate } from 'react-router-dom';

export default function TournamentMenu() {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [menuLevel, setMenuLevel] = React.useState('main'); // 'main' | 'create'
  const open = Boolean(anchorEl);
  const navigate = useNavigate();

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setMenuLevel('main'); // Resetear al menú principal al cerrar
  };

  const handleSelectType = (type) => {
    handleClose();
    navigate(`/tournaments/new?type=${type}`);
  };

  return (
    <div>
      <Button
        id='basic-button'
        aria-controls={open ? 'basic-menu' : undefined}
        aria-haspopup='true'
        aria-expanded={open ? 'true' : undefined}
        onClick={handleClick}
      >
        Nuevo Torneo
      </Button>
      <Menu
        id='basic-menu'
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}
      >
        {menuLevel === 'main' ? [
          <MenuItem 
            key="create"
            onClick={() => setMenuLevel('create')}
            sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 1 }}
          >
            Crear nuevo torneo desde cero
            <ArrowRightIcon key="icon" fontSize="small" />
          </MenuItem>,
          <MenuItem key="import-sp" onClick={handleClose}>Importar desde Swiss Perfect</MenuItem>,
          <MenuItem key="import-cr" onClick={handleClose}>Importar desde Chess Results</MenuItem>
        ] : [
          <MenuItem 
            key="back"
            onClick={() => setMenuLevel('main')}
            sx={{ 
              color: '#94a3b8', 
              display: 'flex', 
              alignItems: 'center', 
              gap: 0.5, 
              borderBottom: '1px solid rgba(255,255,255,0.08)',
              pb: 1,
              mb: 0.5
            }}
          >
            <ArrowLeftIcon fontSize="small" />
            Atrás
          </MenuItem>,
          <MenuItem key="type-normal" onClick={() => handleSelectType('normal')}>Normal</MenuItem>,
          <MenuItem key="type-teams" onClick={() => handleSelectType('teams')}>Por Equipos</MenuItem>
        ]}
      </Menu>
    </div>
  );
}
